import React from 'react';
import Amplify, { Auth } from 'aws-amplify';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withAlert } from 'react-alert';
import PropTypes from 'prop-types';
import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';
import { requestForgetPassword, requestResetPassword } from '../../Actions/actions';
import TextFieldGroup from '../common/TextFieldGroup';
import * as SecretKeys from '../../ENV.json';
import Header from '../Header/header';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

Amplify.configure(SecretKeys.awsUserpool);
class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      code: '',
      password: '',
      cPassword: '',
      resetPassowrd: '',
      errors: {},
      isLoading: false,
      isReset: 1,
      errorsResetPasword: {},
      message: '',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.codeRecive = this.codeRecive.bind(this);
    this.resetPasswordSubmit = this.resetPasswordSubmit.bind(this);
    this.isValidResetPasword = this.isValidResetPasword.bind(this);
    this.isValid = this.isValid.bind(this);
    this.alertMesasage = this.alertMesasage.bind(this);
  }

  componentDidMount() {
    this.setState({ message: '' });
  }

 componentDidUpdate() {
    if(this.props.location.search === "?applicationType=mobile"){
		window.location.href = `${SecretKeys.REACT_APP_FRONTEND_URL}/reset-password-mobile`;
    }
    // window.location =  'collectively://resetpassword/';
//    window.location.href = 'collectively://resetpassword/';
  }


  isValid() {
    const { errors, isValid } = this.validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }

    return isValid;
  }

  validateInput(data) {
    const errors = {};
    if (Validator.isEmpty(data.email)) {
      errors.email = 'Email is required';
      errors.emailError = true;
    }

    return {
      errors,
      isValid: isEmpty(errors),
    };
  }

  isValidResetPasword() {
    const { errorsResetPasword, isValidResetPasword } = this.validateInputResetPasword(this.state);

    if (!isValidResetPasword) {
      this.setState({ errorsResetPasword });
    }

    return isValidResetPasword;
  }

  validateInputResetPasword(data) {
    const re = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');
    const errorsResetPasword = {};
    if (Validator.isEmpty(data.password)) {
      errorsResetPasword.password = 'Password is required';
      errorsResetPasword.passwordError = true;
    }
    if (!re.test(data.password)) {
      errorsResetPasword.password = 'Password must have a minimum of 8 characters which includes 1 capital letter, 1 lower case letter, 1 special characters, and 1 number.';
      errorsResetPasword.passwordError = true;
    }
    if (Validator.isEmpty(data.cPassword)) {
      errorsResetPasword.cPassword = 'Conform password is required';
      errorsResetPasword.cPasswordError = true;
    }
    if (data.cPassword !== '') {
      if (data.cPassword !== data.password) {
        errorsResetPasword.cPassword = 'Conform password and password is not match';
        errorsResetPasword.cPasswordError = true;
      }
    }


    if (Validator.isEmpty(data.code)) {
      errorsResetPasword.code = 'Code is required';
      errorsResetPasword.codeError = true;
    }

    return {
      errorsResetPasword,
      isValidResetPasword: isEmpty(errorsResetPasword),
    };
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value, errors: {}, errorsResetPasword: {} });
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.isValid()) {
      // this.setState({errors: {}, isLoading: true, isReset: 2});
      this.props.requestForgetPassword(this.state);
    }
  }

  codeRecive(e) {
    e.preventDefault();
    const errors = {};
    if (this.state.code !== '') {
      this.setState({ errors: {}, isLoading: true, isReset: 2 });
    } else {
      errors.code = 'Code is required';
      this.setState({
        errors,
      });
    }
    //
  }

  resetPasswordSubmit(e) {
    e.preventDefault();
    if (this.isValidResetPasword()) {
      Auth.forgotPasswordSubmit(this.state.email, this.state.code, this.state.password).then(() => {
        this.alertMesasage();
      }).catch((error) => {
        this.setState({
          message: error.message,
          errorsResetPasword: {
            code: error.message,
            codeError: true,
          },
        });
      });
      // this.setState({errorsResetPasword: {}, isLoading: true, isReset: 4});
      // this.props.requestResetPassword(this.state);
    }
  }

  componentWillReceiveProps(nextProps) {
    const ForgetPasswordData = nextProps.data.ForgetPasswordData ? nextProps.data.ForgetPasswordData : {};
    const ResetPasswordData = nextProps.data.ResetPasswordData ? nextProps.data.ResetPasswordData : {};

    if (ForgetPasswordData.code !== 'undefined' && ForgetPasswordData.code === 200) {
      this.setState({ errors: {}, isLoading: true, isReset: 2 });
    }
    if (ResetPasswordData.response !== 'undefined' && ResetPasswordData.code === 200 && ResetPasswordData.response._v === 'undefined') {
      this.alertMesasage();
    }
    if (ResetPasswordData.response !== 'undefined' && ResetPasswordData.code === 200 && ResetPasswordData.response._v !== 'undefined') {
      // console.log('ResetPasswordData.response._v',ResetPasswordData.response._v)
      // this.setState({message: ResetPasswordData.response._v.message});
    }
  }

  alertMesasage() {
    this.props.alert.success('Password changed successfuly');
    toast.success('Password changed successfully', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      });
    this.context.router.history.push('/');
  }

  render() {
    const {
      email, errors, code, isReset, password, cPassword, errorsResetPasword,
    } = this.state;
    const { ForgetPasswordData, ResetPasswordData } = this.props.data;
    let message = this.state.message;
    if (ResetPasswordData.code !== 'undefined' && ResetPasswordData.code === 400) {
      message = ResetPasswordData.error.message;
    // this.alertMesasage(message);
    }
    if (ForgetPasswordData.code !== 'undefined' && ForgetPasswordData.code === 400) {
      message = ForgetPasswordData.error.message;
    } else {
      message = '';
    }

    return (
      <span>
        <ToastContainer />
        <div className="container">
          <div className="main-content">
            <Header />

            <div className={isReset === 1 ? 'section-content center-align login-content ' : 'hide'}>
              <h2>Forgot your password?</h2>
              <p>Enter your email below and we'll send you a confirmation code to update your password.</p>

              <div className="row error-message">
                <form className="col s12 m8 offset-m2" onSubmit={this.handleSubmit}>
                  <div className="row">
                    <div className="input-field col s12">
                      <TextFieldGroup
                        field="email"
                        label="Email"
                        value={email}
                        error={errors.email}
                        onChange={this.onChange}
                      />
                    </div>

                    <p className="invalid col s12">{message}</p>
                    <div className="col s12">
                      <button className="btn waves-effect waves-light primary-btn col s12" type="submit" name="action">
Reset request
                        <i className="material-icons">arrow_forward</i>
                      </button>
                    </div>
                    <div className="col s12">
                      <div className="create-account">
                        <h5>
Or go back to
                          {' '}
                          <Link to="/">login</Link>
                        </h5>
                      </div>
                    </div>

                  </div>
                </form>
              </div>

            </div>


            <div className={isReset === 4 ? 'section-content center-align login-content ' : 'hide'}>
              <h2>Forgot your password</h2>
              <div className="row">
                <div className="col s8 offset-s2">
                  <p className="invalid col s12 left-align">Please enter the code you received in your registered Email</p>
                </div>

              </div>
              <div className="row error-message">
                <form className="col s8 offset-s2" onSubmit={this.codeRecive}>
                  <div className="row">
                    <div className="input-field col s12">
                      <TextFieldGroup
                        field="code"
                        label="Code"
                        value={code}
                        error={errors.code}
                        onChange={this.onChange}
                      />
                    </div>
                    <p className="invalid col s12">{message}</p>
                    <div className="col s12">
                      <button className="btn waves-effect waves-light primary-btn col s12" type="submit" name="action">
Submit Reset
                        <i className="material-icons">arrow_forward</i>
                      </button>
                    </div>
                    <div className="col s12">
                      <div className="create-account">
                        <h5>
Or go back to
                          {' '}
                          <Link to="/">login</Link>
                        </h5>
                      </div>
                    </div>

                  </div>
                </form>
              </div>

            </div>

            <div className={isReset === 2 ? 'section-content  center-align login-content ' : 'hide'}>
              <h2>Forgot your password</h2>
              <p>Please enter the code you received in your registered email and enter New password</p>

              <div className="row error-message">
                <form className="col s8 offset-s2" onSubmit={this.resetPasswordSubmit}>
                  <div className="row">
                    <div className="input-field col s12">
                      <TextFieldGroup
                        field="code"
                        label="Code"
                        value={code}
                        error={errorsResetPasword.code}
                        onChange={this.onChange}
                      />
                    </div>
                    <div className="input-field col s12">
                      <TextFieldGroup
                        field="password"
                        label="New Password"
                        value={password}
                        error={errorsResetPasword.password}
                        onChange={this.onChange}
                        type="password"
                      />
                    </div>

                    <div className="input-field col s12">
                      <TextFieldGroup
                        field="cPassword"
                        label="Confirm Password"
                        value={cPassword}
                        error={errorsResetPasword.cPassword}
                        onChange={this.onChange}
                        type="password"
                      />
                    </div>

                    <p className="invalid col s12">{message}</p>
                    <div className="col s12">
                      <button className="btn waves-effect waves-light primary-btn col s12" type="submit" name="action">
Reset
                        <i className="material-icons">arrow_forward</i>
                      </button>
                    </div>
                    <div className="col s12">
                      <div className="create-account">
                        <h5>
Or go back to
                          {' '}
                          <Link to="/">login</Link>
                        </h5>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

ForgotPassword.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators({ requestForgetPassword, requestResetPassword }, dispatch);

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(ForgotPassword));
